import { useEffect } from 'react';
import '../../Style/form-submit/fill.css';
import { t } from 'i18next';
import { getFileTemp, getWard, uploadImageTemp } from '../../Services/api-service';
import { isNullOrEmpty, isValidAddress, numberOnly, removeDotFromStringMoney } from '../../Services/service';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from 'dayjs';
import { vi } from 'date-fns/locale';
import { error, success, warning } from '../../Components/custom-toast/CustomToast';
import CustomUploadButtonColor from '../../Components/custom-button/CustomUploadButtonColor';
import Select from "react-select";
import CustomButtonColor from '../../Components/custom-button/CustomButtonColor';

function FillInformationSection({objectDto, setObjectDto, setLoading, province, changeEmail,  ward, setWard, contactWard, setContactWard, occupation, imgBack, imgFront, setImgBack, setImgFront}){
    const customSelectStyles = {
        control: (provided) => ({
            ...provided,
            border: "none",
            boxShadow: "none",
            padding: 0,
            minHeight: "unset",
            height: "100%",
            backgroundColor: "transparent"
        }),

        valueContainer: (provided) => ({
            ...provided,
            padding: 0
        }),

        input: (provided) => ({
            ...provided,
            margin: 0,
            padding: 0
        }),

        singleValue: (provided) => ({
            ...provided,
            margin: 0,
            padding: 0
        }),

        placeholder: (provided) => ({
            ...provided,
            margin: 0
        }),
        
        indicatorsContainer: (provided) => ({
            ...provided,
            padding: 0,   
            height: "100%"
        }),
        clearIndicator: (provided) => ({
            ...provided,
            padding: 0,   
            height: "100%"
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: 0  
        }),

        indicatorSeparator: () => ({
            display: "none"
        }),

        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            margin: "1% 0 0 -1.5%"
        }),

        option: (provided, state) => ({
            ...provided,
            padding: "6px 10px",
            backgroundColor: state.isSelected
            ? "#1d3c70"
            : state.isFocused
            ? "#f2f2f2"
            : "white",
            color: state.isSelected ? "white" : "black",
            cursor: "pointer"
        })
    };
    const handleImageFrontUpload = async (e) => {
        setLoading(true);
        try {
            const file = e.target.files[0];
            if (!file || !file.type.includes("image")) {
                setLoading(false);
                return error(t("messagewronguploadimage"));
            }
            const fileSizeMB = file.size / (1024 * 1024); 
            if(fileSizeMB > 10){
                setLoading(false);
                return error(t("messagebiguploadimage"));
            }
            const reader = new FileReader();
            reader.onloadend = async () => {
                try {
                    if(isNullOrEmpty(localStorage.getItem("%##%"))) return warning("Hết thời gian thao tác, vui lòng thử lại");
                    const isSuccess = await uploadImageTemp(file, localStorage.getItem("%##%"), "FRONT_", setLoading);
                    if (isSuccess) {
                        const dataPush = {
                            base64: reader.result
                        };
                        setImgFront(dataPush);
                        setLoading(false);
                        return success(t("messagesuccessuploadimage"));
                    } else {
                        setLoading(false);
                        return error(t("messagefailuploadimage"));
                    }
                } catch (innerError) {
                    error(t("messagefailuploadimage"));
                    setLoading(false);
                }
            };
            reader.readAsDataURL(file);
        } catch (outerError) {
            error(t("messagefailuploadimage"));
            setLoading(false);
        }
    };
    const handleImageBackUpload = async (e) => {
        setLoading(true);
        try {
            const file = e.target.files[0];
            if (!file || !file.type.includes("image")) {
                setLoading(false);
                return error(t("messagewronguploadimage"));
            }
            const fileSizeMB = file.size / (1024 * 1024); 
            if(fileSizeMB > 10){
                setLoading(false);
                return error(t("messagebiguploadimage"));
            }
            const reader = new FileReader();
            reader.onloadend = async () => {
                try {
                    if(isNullOrEmpty(localStorage.getItem("%##%"))) return warning("Hết thời gian thao tác, vui lòng thử lại");
                    const isSuccess = await uploadImageTemp(file, localStorage.getItem("%##%"), "BACK_", setLoading);
                    if (isSuccess) {
                        const dataPush = {
                            base64: reader.result
                        };
                        setImgBack(dataPush);
                        setLoading(false);
                        return success(t("messagesuccessuploadimage"));
                    } else {
                        setLoading(false);
                        return error(t("messagefailuploadimage"));
                    }
                } catch (innerError) {
                    error(t("messagefailuploadimage"));
                    setLoading(false);
                }
            };
            reader.readAsDataURL(file);
        } catch (outerError) {
            error(t("messagefailuploadimage"));
            setLoading(false);
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setObjectDto(prev=>({ ...prev, [name]: value }));
    };
    const handleCopyFromAddress = () => {
        if(objectDto.provinceCode != null){
            setLoading(true);
            getWard(objectDto.provinceCode, setContactWard, setLoading);
        }
        setObjectDto(prev => ({...prev, contactProvinceCode : objectDto.provinceCode, contactWardCode: objectDto.wardCode, contactAddress: objectDto.address}));
    }
    const handleChangeWard = (selected, fieldName) => {
        setObjectDto(prev => ({
            ...prev,
            [fieldName]: selected ? selected.value : ""
        }));
    };
    // const handleChangeOccupation = (e) => {
    //     const { value } = e.target;
    //     const valueOccupation = JSON.parse(value);
    //     setObjectDto(prev=>({ ...prev, occupationId: valueOccupation.id, occupationCode: valueOccupation.code }));
    // };
    const handleChangeOccupation = (selected) => {
        if (!selected) {
            setObjectDto(prev => ({
                ...prev,
                occupationId: "",
                occupationCode: ""
            }));
            return;
        }

        setObjectDto(prev => ({
            ...prev,
            occupationId: selected.value,
            occupationCode: selected.code
        }));
    };
    const handleChangeNumber = (e) => {
        const { name, value } = e.target;
        if(numberOnly(value)){
            setObjectDto(prev=>({ ...prev, [name]: value }));
        }
        if(isNullOrEmpty(value)){
            setObjectDto(prev=>({ ...prev, [name]: "" }));
        }
    };
    const handleChangeDate = (newValue) => {
        if(isNullOrEmpty(newValue)) return setObjectDto(prev => ({...prev, iddate: null}));
        return setObjectDto(prev => ({...prev, iddate: dayjs(newValue).format("YYYY-MM-DD")}));
    }
    // const handleChangePlace = (e, position) => {
    //     const { name, value } = e.target;
    //     setObjectDto(prev=>({ ...prev, [name]: value }));
    //     setLoading(true);
    //     if(position === "1"){
    //         setObjectDto(prev=> ({...prev, wardCode: ""}));
    //         return getWard(value, setWard, setLoading);
    //     }else{
    //         setObjectDto(prev=> ({...prev, contactWardCode: ""}));
    //         return getWard(value, setContactWard, setLoading);
    //     }
    // };
    const handleChangePlace = (selected, position) => {
        const value = selected ? selected.value : "";

        if (position === "1") {
            setObjectDto(prev => ({
                ...prev,
                provinceCode: value,
                wardCode: ""
            }));

            if (value) {
                setLoading(true);
                getWard(value, setWard, setLoading);
            } else {
                setWard([]);
            }

        } else {
            setObjectDto(prev => ({
                ...prev,
                contactProvinceCode: value,
                contactWardCode: ""
            }));

            if (value) {
                setLoading(true);
                getWard(value, setContactWard, setLoading);
            } else {
                setContactWard([]);
            }
        }
    };
    const now = new Date();
    const minDate = new Date("1900-01-01T00:00:00");
    useEffect(()=>{
        document.body.style.overflow = "auto";
        if(isNullOrEmpty(localStorage.getItem("%##%"))) warning("Hết thời gian thao tác, vui lòng thử lại");
        else getFileTemp(localStorage.getItem("%##%"), setLoading, setImgFront, setImgBack);
    },[]);
    return(
        <section className="fill-information">
            <div className="fill-information-wrapper">
                <div className="fill-infor-form">
                    <div className="title-fill-infor-wrap">
                        <h2 className="title-font-fill-infor">{t("productinformation")}</h2>
                    </div>
                    <div className="border-form-list">
                        <div className="border-form">
                        <span className="col-md-12 col-sm-12 col-xs-12 title-form">
                            {t("product")}
                        </span>
                        <span className="col-md-12 col-sm-12 col-xs-12 value-form">
                            {objectDto.description + " - " + objectDto.productName}
                        </span>
                        </div>
                        <div className="border-form">
                        <span className="col-md-12 col-sm-12 col-xs-12 title-form">
                            {t("moneypolicy")}
                        </span>
                        <span className="col-md-12 col-sm-12 col-xs-12 value-form">
                            {objectDto.strSumAssured}
                            
                        </span>
                        </div>
                    <div className="border-form">
                        <span className="col-md-12 col-sm-12 col-xs-12 title-form">
                            {t("feepolicy")}
                        </span>

                        <span className="col-md-12 col-sm-12 col-xs-12 value-form">
                            {
                                !isNullOrEmpty(objectDto.discount)  && objectDto.discount > 0 ?
                                ( <>
                                    <span className="old-premium">
                                        {removeDotFromStringMoney(objectDto.premiumOrigin)}{" "}
                                        {t("vnd")}
                                        {t("peryear")}
                                    </span>
                                    <span className="split-premium">{" "}</span>
                                    <span className="new-premium">
                                        {removeDotFromStringMoney(objectDto.premium)}{" "}
                                        {t("vnd")}
                                        {t("peryear")}
                                    </span>
                                    </>
                                ) :
                                <span className="col-md-12 col-sm-12 col-xs-12 value-form">
                                    {removeDotFromStringMoney(objectDto.premium)}
                                    {" "} 
                                    {t("vnd")}
                                    {t("peryear")}
                                </span>
                                }
                        </span>
                    </div>
                </div>

                    <div className="title-fill-infor-wrap">
                        <h2 className="title-font-fill-infor">{t("inforpoequalinforlatitle")}</h2>
                        <p className='normal-text'>{t("inforpoequalinforladesc")}</p>
                    </div>
                    
                    <div className="form-group-fill-information one-column">
                        <label className='lbl-wbox-fill required'>{t("fullnamefill")}</label>
                        <input className='ipt-box-wlabel' type="text" name="fullName" disabled value={objectDto.fullName} placeholder="" style={{width: "100%"}}/>
                    </div>
                    <div className='form-group-list-fill-information'>
                        <div className="form-group-fill-information same-line third-column ">
                            <label className='lbl-wbox-fill required'>{t("birthfill")}</label>
                            <DatePicker name="birthDate" 
                                    selected={objectDto.dob}
                                    dateFormat="dd/MM/yyyy" 
                                    locale="en-GB"
                                    className="ipt-box-wlabel custom-datepicker"
                                    disabled
                                />
                        </div>

                        <div className="form-group-fill-information same-line third-column">
                            <label className='lbl-wbox-fill required'>{t("genderfill")}</label>
                            <select className='ipt-box-wlabel' name="gender" disabled value={objectDto.gender}>
                                <option className='ipt-box-wlabel' value="">{t("genderchoosefill")}</option>
                                <option className='ipt-box-wlabel' value="0">{t("gendermale")}</option>
                                <option className='ipt-box-wlabel' value="1">{t("genderfemale")}</option>
                            </select>
                        </div>

                        <div className="form-group-fill-information same-line third-column">
                            <label className='lbl-wbox-fill one-line required'>{t("phonenumberfill")}</label>
                            <input className='ipt-box-wlabel' type="text" name="phoneNumber" disabled value={objectDto.phoneNumber} />
                        </div>
                    </div>
                    
                    <div className='form-group-list-fill-information'>
                        <div className="form-group-fill-information same-line two-column ">
                            <label className='lbl-wbox-fill required'>{t("birthplacefill")}</label>
                            {/* <select className='ipt-box-wlabel-fill-select' name="birthPlace" value={objectDto.birthPlace}  onChange={handleChange}>
                                <option className='ipt-box-wlabel' value="">{t("pleasefill")}</option>
                                {
                                    province !== undefined ? province.map((item, index)=> {
                                        return <option key={index} className='ipt-box-wlabel' value={item.code}>{item.name}</option>
                                    }) : <></>
                                }
                            </select> */}
                            <Select
                                className="ipt-box-wlabel-fill-select"
                                styles={customSelectStyles}
                                options={
                                    province?.map(item => ({
                                        value: item.code,
                                        label: item.name
                                    })) || []
                                }
                                value={
                                    province?.find(p => p.code === objectDto.birthPlace)
                                        ? {
                                            value: objectDto.birthPlace,
                                            label: province.find(p => p.code === objectDto.birthPlace)?.name
                                        }
                                        : null
                                }
                                onChange={(selected) =>
                                    setObjectDto(prev => ({
                                        ...prev,
                                        birthPlace: selected ? selected.value : ""
                                    }))
                                }
                                filterOption={(option, inputValue) => {
                                    const normalize = (str) =>
                                        str
                                            .normalize("NFD")
                                            .replace(/[\u0300-\u036f]/g, "")
                                            .toLowerCase();

                                    return normalize(option.label).includes(normalize(inputValue));
                                }}
                                placeholder={t("pleasefill")}
                                isSearchable
                                isClearable
                            />
                        </div>

                        <div className="form-group-fill-information same-line two-column">
                            <label className='lbl-wbox-fill one-line required'>{t("maritalfill")}</label>
                            <div className='same-line'>
                                <label className='ipt-radio-wlabel'> <input type="radio" name="married" value="0" checked={objectDto.married === "0"} onChange={handleChange} /> {t("singlemarital")}</label>
                                <label className='ipt-radio-wlabel'> <input type="radio" name="married" value="1" checked={objectDto.married === "1"} onChange={handleChange}/> {t("marriagemarital")} </label>
                            </div>
                        </div>
                    </div>
                    <div className='form-group-list-fill-information'>
                        <div className='form-group-fill-information same-line one-column'>
                            <label className='lbl-wbox-fill required'>{t("occupationfill")}</label>
                            {/* <select className='ipt-box-wlabel-fill-select' name="occupationId" value={JSON.stringify({"id": objectDto.occupationId, "code": objectDto.occupationCode})} onChange={handleChangeOccupation}>
                                <option className='ipt-box-wlabel' value="">{t("pleasefill")}</option>
                                {
                                    occupation !== undefined ? occupation.map((item, index)=> {
                                        return <option key={index} className='ipt-box-wlabel' value={JSON.stringify({"id": item.id, "code": item.occupationCode})}>{item.descriptionVn}</option>
                                    }) : <></>
                                }
                            </select> */}
                            <Select
                                className="ipt-box-wlabel-fill-select"
                                styles={customSelectStyles}
                                options={
                                    occupation?.map(item => ({
                                        value: item.id,
                                        label: item.descriptionVn,
                                        code: item.occupationCode
                                    })) || []
                                }
                                filterOption={(option, inputValue) => {
                                    const normalize = (str) =>
                                        str
                                            .normalize("NFD")
                                            .replace(/[\u0300-\u036f]/g, "")
                                            .toLowerCase();

                                    return normalize(option.label).includes(normalize(inputValue));
                                }}
                                value={
                                    occupation?.find(o => o.id === objectDto.occupationId)
                                        ? {
                                            value: objectDto.occupationId,
                                            label: occupation.find(o => o.id === objectDto.occupationId)?.descriptionVn,
                                            code: occupation.find(o => o.id === objectDto.occupationId)?.occupationCode
                                        }
                                        : null
                                }
                                onChange={handleChangeOccupation}
                                placeholder={t("pleasefill")}
                                isSearchable
                                isClearable
                            />
                        </div>
                    </div>
                    <div className='form-group-list-fill-information'>
                        <div className="form-group-fill-information same-line third-column">
                            <label className='lbl-wbox-fill required'>{t("idfill")}</label>
                            <input className='ipt-box-wlabel' type="text" name="idnumber" maxLength={12} value={objectDto.idnumber} onChange={handleChangeNumber} placeholder={t("pleasefill")}/>
                        </div>

                        <div className="form-group-fill-information same-line third-column">
                            <label className='lbl-wbox-fill required'>{t("dateidfill")}</label>
                            <DatePicker 
                                selected={objectDto.iddate} 
                                onChange={handleChangeDate} 
                                dateFormat="dd/MM/yyyy"
                                minDate={minDate}
                                maxDate={now}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                locale={vi} className="ipt-box-wlabel" 
                            />
                        </div>

                        <div className="form-group-fill-information same-line third-column">
                            <label className='lbl-wbox-fill required'>{t("placeidfill")}</label>
                            <input className='ipt-box-wlabel' type="text" name="idplace" value={objectDto.idplace} onChange={handleChange} placeholder={t("pleasefill")}/>
                        
                        </div>
                    </div>

                    <div className="id-upload-container">
                        <div className="image-display-group">
                            {/* FRONT IMAGE + BUTTON */}
                            <div className="image-button-column">
                                <div className="image-placeholder">
                                    {
                                    !isNullOrEmpty(imgFront)
                                        ? <>
                                            <img src={imgFront.base64} alt={t("fontidimage")} />
                                            {/* <span className="delete-icon" onClick={() => handleDeleteImage('1')}>&#10005;</span> */}
                                        </>
                                        : <p>{t("fontidimage")}</p>
                                    }
                                </div>
                                <CustomUploadButtonColor title={"Tải ảnh mặt trước"} accept=".png,.jpg,.gif" onChange={handleImageFrontUpload} color={"white"} bgColor={"black"} />
                            </div>

                            {/* BACK IMAGE + BUTTON */}
                            <div className="image-button-column">
                                <div className="image-placeholder">
                                    {
                                    !isNullOrEmpty(imgBack)
                                        ? <>
                                            <img src={imgBack.base64} alt={t("backidimage")} />
                                            {/* <span className="delete-icon" onClick={() => handleDeleteImage('2')}>&#10005;</span> */}
                                        </>
                                        : <p>{t("backidimage")}</p>
                                    }
                                </div>
                                <CustomUploadButtonColor title={"Tải ảnh mặt sau"} accept=".png,.jpg,.gif"  onChange={handleImageBackUpload} color={"white"} bgColor={"black"} />
                            </div>
                        </div>
                    </div>


                    <div className="form-group-fill-information same-line one-column">
                        <label className='lbl-wbox-fill required'>{t("emailfill")}</label>
                        <input className='ipt-box-wlabel' type="text" name="email" disabled={!changeEmail} value={objectDto.email} onChange={handleChange} placeholder={t("pleasefill")}/>
                    </div>
                    <label className='lbl-wbox-fill required'><strong>{t("addressfill")}</strong></label>
                    <div className='form-group-list-fill-information-select'>
                        <div className="form-group-fill-information-select same-line third-column">
                            <label className='lbl-wbox-fill required'>{t("provincefill")}</label>
                            {/* <select className='ipt-box-wlabel-fill-select' name="provinceCode" value={objectDto.provinceCode} onChange={(e) =>handleChangePlace(e, "1")}>
                                <option className='ipt-box-wlabel' value="">{t("pleasefill")}</option>
                                    {
                                        province !== undefined ? province.map((item, index)=> {
                                            return <option key={index} className='ipt-box-wlabel' value={item.code}>{item.name}</option>
                                        }) : <></>
                                    }
                            </select> */}
                            <Select className="ipt-box-wlabel-fill-select"
                                styles={customSelectStyles}
                                options={
                                    province?.map(item => ({
                                        value: item.code,
                                        label: item.name
                                    })) || []
                                }
                                filterOption={(option, inputValue) => {
                                    const normalize = (str) =>
                                        str
                                            .normalize("NFD")
                                            .replace(/[\u0300-\u036f]/g, "")
                                            .toLowerCase();

                                    return normalize(option.label).includes(normalize(inputValue));
                                }}
                                value={
                                    province?.find(p => p.code === objectDto.provinceCode)
                                        ? {
                                            value: objectDto.provinceCode,
                                            label: province.find(p => p.code === objectDto.provinceCode)?.name
                                        }
                                        : null
                                }
                                onChange={(selected) => handleChangePlace(selected, "1")}
                                placeholder={t("pleasefill")}
                                isSearchable
                                isClearable
                            />
                        </div>

                        {/* <div className="form-group-fill-information-select same-line third-column">
                            <label className='lbl-wbox-fill required'>{t("districtfill")}</label>
                            <select className='ipt-box-wlabel-fill-select' name="districtCode" value={objectDto.districtCode} onChange={(e) => handleChangePlace(e, "1", "2")}>
                                <option className='ipt-box-wlabel' value="">{t("pleasefill")}</option>
                                    {
                                        district !== undefined ? district.map((item, index)=> {
                                            return <option key={index} className='ipt-box-wlabel' value={item.code}>{item.name}</option>
                                        }) : <></>
                                    }
                            </select>
                        </div> */}

                        <div className="form-group-fill-information-select same-line third-column">
                            <label className='lbl-wbox-fill required'>{t("wardfill")}</label>
                            {/* <select className='ipt-box-wlabel-fill-select' name="wardCode" value={objectDto.wardCode} onChange={handleChange}>
                                <option className='ipt-box-wlabel' value="">{t("pleasefill")}</option>
                                    {
                                        ward !== undefined ? ward.map((item, index)=> {
                                            return <option key={index} className='ipt-box-wlabel' value={item.code}>{item.name}</option>
                                        }) : <></>
                                    }
                            </select> */}
                            <Select
                                className="ipt-box-wlabel-fill-select"
                                styles={customSelectStyles}
                                options={
                                    ward?.map(item => ({
                                        value: item.code,
                                        label: item.name
                                    })) || []
                                }
                                filterOption={(option, inputValue) => {
                                    const normalize = (str) =>
                                        str
                                            .normalize("NFD")
                                            .replace(/[\u0300-\u036f]/g, "")
                                            .toLowerCase();

                                    return normalize(option.label).includes(normalize(inputValue));
                                }}
                                value={
                                    ward?.find(w => w.code === objectDto.wardCode)
                                        ? {
                                            value: objectDto.wardCode,
                                            label: ward.find(w => w.code === objectDto.wardCode)?.name
                                        }
                                        : null
                                }
                                onChange={(selected) => handleChangeWard(selected, "wardCode")}
                                placeholder={t("pleasefill")}
                                isSearchable
                                isClearable
                            />
                        </div>
                    </div>
                    <div className="form-group-fill-information same-line one-column">
                        <label className='lbl-wbox-fill required'>{t("roadfill")}</label>
                        <input className='ipt-box-wlabel' type="text" maxLength={60} name="address" value={objectDto.address} onChange={handleChange} placeholder={t("pleasefill")}/>
                    </div>
                    
                    <div className="form-group-fill-information same-line one-column">
                        <label className='lbl-wbox-fill required'><strong>{t("addresscontactfill")}</strong></label>
                        {/* <input className='ipt-box-wlabel' type="text" maxLength={60} name="address" value={objectDto.address} onChange={handleChange} placeholder={t("pleasefill")}/> */}
                        <CustomButtonColor title={"Sao chép từ địa chỉ thường trú"} onClick={handleCopyFromAddress} color={"white"} bgColor={"black"} />
                    </div>
                    <div className='form-group-list-fill-information-select'>
                        <div className="form-group-fill-information-select same-line third-column">
                            <label className='lbl-wbox-fill required'>{t("provincefill")}</label>
                            {/* <select className='ipt-box-wlabel-fill-select' name="contactProvinceCode" value={objectDto.contactProvinceCode} onChange={(e) =>handleChangePlace(e, "2")}>
                                <option className='ipt-box-wlabel' value="">{t("pleasefill")}</option>
                                    {
                                        province !== undefined ? province.map((item, index)=> {
                                            return <option key={index} className='ipt-box-wlabel' value={item.code}>{item.name}</option>
                                        }) : <></>
                                    }
                            </select> */}
                            <Select
                                className="ipt-box-wlabel-fill-select"
                                styles={customSelectStyles}
                                options={
                                    province?.map(item => ({
                                        value: item.code,
                                        label: item.name
                                    })) || []
                                }
                                filterOption={(option, inputValue) => {
                                    const normalize = (str) =>
                                        str
                                            .normalize("NFD")
                                            .replace(/[\u0300-\u036f]/g, "")
                                            .toLowerCase();

                                    return normalize(option.label).includes(normalize(inputValue));
                                }}
                                value={
                                    province?.find(p => p.code === objectDto.contactProvinceCode)
                                        ? {
                                            value: objectDto.contactProvinceCode,
                                            label: province.find(p => p.code === objectDto.contactProvinceCode)?.name
                                        }
                                        : null
                                }
                                onChange={(selected) => handleChangePlace(selected, "2")}
                                placeholder={t("pleasefill")}
                                isSearchable
                                isClearable
                            />
                        </div>

                        {/* <div className="form-group-fill-information-select same-line third-column">
                            <label className='lbl-wbox-fill required'>{t("districtfill")}</label>
                            <select className='ipt-box-wlabel-fill-select' name="contactDistrictCode" value={objectDto.contactDistrictCode} onChange={(e) => handleChangePlace(e, "2", "2")}>
                                <option className='ipt-box-wlabel' value="">{t("pleasefill")}</option>
                                    {
                                        contactDistrict !== undefined ? contactDistrict.map((item, index)=> {
                                            return <option key={index} className='ipt-box-wlabel' value={item.code}>{item.name}</option>
                                        }) : <></>
                                    }
                            </select>
                        </div> */}

                        <div className="form-group-fill-information-select same-line third-column">
                            <label className='lbl-wbox-fill required'>{t("wardfill")}</label>
                            {/* <select className='ipt-box-wlabel-fill-select' name="contactWardCode" value={objectDto.contactWardCode} onChange={handleChange}>
                                <option className='ipt-box-wlabel' value="">{t("pleasefill")}</option>
                                    {
                                        contactWard !== undefined ? contactWard.map((item, index)=> {
                                            return <option key={index} className='ipt-box-wlabel' value={item.code}>{item.name}</option>
                                        }) : <></>
                                    }
                            </select> */}
                            <Select
                                className="ipt-box-wlabel-fill-select"
                                styles={customSelectStyles}
                                options={
                                    contactWard?.map(item => ({
                                        value: item.code,
                                        label: item.name
                                    })) || []
                                }
                                filterOption={(option, inputValue) => {
                                    const normalize = (str) =>
                                        str
                                            .normalize("NFD")
                                            .replace(/[\u0300-\u036f]/g, "")
                                            .toLowerCase();

                                    return normalize(option.label).includes(normalize(inputValue));
                                }}
                                value={
                                    contactWard?.find(w => w.code === objectDto.contactWardCode)
                                        ? {
                                            value: objectDto.contactWardCode,
                                            label: contactWard.find(w => w.code === objectDto.contactWardCode)?.name
                                        }
                                        : null
                                }
                                onChange={(selected) => handleChangeWard(selected, "contactWardCode")}
                                placeholder={t("pleasefill")}
                                isSearchable
                                isClearable
                            />
                        </div>
                    </div>
                    <div className="form-group-fill-information same-line one-column">
                        <label className='lbl-wbox-fill required'>{t("roadfill")}</label>
                        <input className='ipt-box-wlabel' type="text" maxLength={60} name="contactAddress" value={objectDto.contactAddress} onChange={handleChange} placeholder={t("pleasefill")}/>
                    </div>

                    <div className='form-group-list-fill-information'>
                        <div className="form-group-fill-information same-line third-column">
                            <label className='lbl-wbox-fill'>{t("agentcode")}</label>
                            <input className='ipt-box-wlabel' maxLength={20} type="text" name="agentNumber" value={objectDto.agentNumber} onChange={handleChange}/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default FillInformationSection;